export const add_bank_account_illustration = require("./addBankAccountillustration.svg");
export const add_it_anyways_illustration = require("./addItAnywaysillustration.svg");
export const bank_account_details_illustration = require("./bankAccountDetailsillustration.svg");
export const empty_folder_icon = require("./emptyFolderIcon.svg");
export const xero_logo = require("./xeroLogo.svg");
